// WCAG relative luminance / contrast ratio, per https://www.w3.org/WAI/GL/wiki/Relative_luminance
function srgbChannelToLinear(c: number) {
  const normalized = c / 255
  return normalized <= 0.03928 ? normalized / 12.92 : ((normalized + 0.055) / 1.055) ** 2.4
}

function relativeLuminance(hex: string) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return (
    0.2126 * srgbChannelToLinear(r) +
    0.7152 * srgbChannelToLinear(g) +
    0.0722 * srgbChannelToLinear(b)
  )
}

/** Picks white or near-black text for a given background hex, whichever passes WCAG AA (4.5:1)
 *  for small/bold text — or whichever contrasts more if neither reaches 4.5:1. Some brand marker
 *  colors (e.g. the amber "AT Demonstration" token) are ~3:1 against white, which fails AA when
 *  used as small bold label text on a solid-color badge; this keeps those badges readable without
 *  having to darken the brand color itself (which is also used for map dots/legend/swatches). */
export function getReadableTextColor(backgroundHex: string): string {
  const bgLuminance = relativeLuminance(backgroundHex)
  const contrastWithWhite = (1 + 0.05) / (bgLuminance + 0.05)
  const contrastWithBlack = (bgLuminance + 0.05) / (0 + 0.05)
  if (contrastWithWhite >= 4.5 && contrastWithWhite >= contrastWithBlack) return '#fff'
  if (contrastWithBlack >= 4.5) return '#1a1a1a'
  return contrastWithWhite > contrastWithBlack ? '#fff' : '#1a1a1a'
}
